import { LoaderFunction, useFetcher } from "react-router-dom";

type LoaderData = Promise<null>;

export const timeoutLoader: LoaderFunction = async (): LoaderData => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(null), 50);
  });
};

export function useTimeoutFetcher() {
  return useFetcher<LoaderData>({ key: "search-timeout" });
}
